import { Component, inject } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FuelConsumptionFullModal } from '../fuel-consumption-full-modal/fuel-consumption-full-modal.component';
import { ChartData, MultiLineChartComponent, PieChartComponent } from '../../../../_shared';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-fuel-consumption-modal',
  standalone: true,
  imports: [MultiLineChartComponent, PieChartComponent, TranslocoDirective], //, PieChart, LinechartDistance
  templateUrl: './fuel-consumption-modal.component.html',
  styleUrl: './fuel-consumption-modal.component.scss',
  providers: [],
})

export class FuelConsumptionModal {
  private readonly modalRef = inject(NgbActiveModal);
  private readonly modalService = inject(NgbModal);

  public value!: number;

  protected lineChartData: any[] = ChartData.fuelConsumption;

  protected lineConfigs: any[] = ChartData.fuelConsumptionLineConfig;

  // public fullChart = signal<boolean>(false);

  ngOnInit(): void {
  }

  fullChartClick(): void {
    // this.dialog.open(FuelConsumptionFullModal, {
    //   panelClass: "fuelGraphModal",
    // })

    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    };
    const modalRef = this.modalService.open(FuelConsumptionFullModal, modalOptions);
  }

  closeModal(): void {
    this.modalRef.close();
  }
}
